module.exports = __webpack_public_path__ + "static/media/NimbusSanL-Reg.ef36b2c9.otf";